import React from 'react'
import { Button } from '@material-ui/core';


export class TopButtons extends React.Component {
    render(){
        return(
       <div style={{maxWidth:250, minWidth:250, margin:'auto'}}>
            <div>
            <Button onClick={()=>{this.props.buttonSelected(this.props.b.id)}} style={{ height:120, 
                                                                                    borderRadius:25,
                                                                                    fontWeight:600, 
                                                                                    backgroundColor:this.props.b.color, 
                                                                                    width:'80%', 
                                                                                    color:'white',
                                                                                    borderColor:'transparent' }} 
                                
                                variant="outlined">{this.props.b.label}</Button>
                              

            </div>
            <div style={{                           display:this.props.buttonSelectat === this.props.b.id? 'block' : 'none',
                                                    width: 0,
                                                    height: 0,
                                                    borderLeft: '85px solid transparent',
                                                    borderRight: '85px solid transparent',
                                                    margin:'auto',
                                                    borderTop: `20px solid ${this.props.b.color}`,
                                                    
                                                }}>

                                </div>
    
               

                </div>
       
            )
        
    }
  
}